import {lazy} from 'react';

export const TabNavigationLazy = lazy(() => import(/* webpackChunkName: "tabNavigation" */ '.'));
